import Vue from "vue";
import axios from "axios";
import CryptoJS from 'crypto-js'
import VueRouter from "vue-router";

import {
  Loading,
  Message,
  Notification
} from "element-ui";
var key = 'nw-hgp$1e5(9_u(7'
var loadinginstace, title;
// 添加请求拦截器
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

//AES加密
function encrypt(word, keyStr) {
  keyStr = keyStr ? keyStr : key;
  var key = CryptoJS.enc.Utf8.parse(keyStr);
  var srcs = CryptoJS.enc.Utf8.parse(word);
  var encrypted = CryptoJS.AES.encrypt(srcs, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.toString();
}
//AES解密
function decrypt(word, keyStr) {
  keyStr = keyStr ? keyStr : key;
  var key = CryptoJS.enc.Utf8.parse(keyStr);
  var decrypt = CryptoJS.AES.decrypt(word, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  return CryptoJS.enc.Utf8.stringify(decrypt).toString();
}



axios.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    if (title == 1) {
      config.headers.token = "";
    } else {
      if (sessionStorage.getItem("token")) {
        config.headers.token = sessionStorage.getItem("token");
      }
    }

    return config;
  },
  error => {
    // 对请求错误做些什么
    // console.log(error)
    // loadinginstace = Loading.service({ fullscreen: true })
    // Message.error({
    //   message: '加载超时'
    // })
    // loadinginstace.close()
    return Promise.reject(error);
  }
);
// 添加响应拦截器
axios.interceptors.response.use(
  response => {
    // 对响应数据做点什么
    return response.data;
  },
  function (error) {
    // 对响应错误做点什么

    Message.error({
      message: "加载超时,请刷新"
    });
    return Promise.reject(error);
  }
);
let development = process.env.NODE_ENV == "development" ? true : false;

// 这是线上
let url_Api = "";
// 这是线下
if (!development) {
  url_Api = "api";
}

function require(type, url, data) {
  // if (data.title == 1) {
  //   title = 1;
  //   console.log(data.title, title);
  // } else {
  //   title = 0;
  // }
  console.log(data)
  let option = new URLSearchParams();
  if (data instanceof Object) {
    for (var prop in data) {
      console.log(prop)
      if (data[prop] instanceof Object) {
        option.append(prop, JSON.stringify(data[prop]));
      } else {
        option.append(prop, data[prop]);
        console.log(prop, data[prop])
      }
    }
  }
  // console.log(option.get('year'))
  let ajaxConfig = {
    method: type,
    url: url_Api + url,
    // url: url,
    data: option,
    proxy: true //支持代理解决跨域
  };
  console.log(ajaxConfig)
  var promise = new Promise(function (resolve, ) {
    axios(ajaxConfig).then(res => {
      // console.log(res, '加密')
      // console.log(res)
      let resData = ''
      if (typeof res == 'string') {
        if (development) {
          // url_Api = "api";
          // console.log('请求方式', type, '请求地址', url, '传递数据', option, '解码', decrypt(res, key),)

        }
        resData = JSON.parse(decrypt(res, key))

      } else {
        resData = res

      }

      let code = resData.code
      if (code == 100007 || code == 110006) {
        Message.warning("该账号已在其他设备登录，请重新登录")
        console.log(resData.code, VueRouter)
        window.vm.$router.push('/');
      } else {
        resolve(resData);
      }

    })
  })
  return promise;

}
export {
  require,
  url_Api
};



// WEBPACK FOOTER //
// ./src/utils/http_request.js